import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { CodNuevoBand, CodRecibidoBand, CodTipoFichaFUR, ConvertDateTimeToStrForBD, DscMensajeSpinner, DscMensajeValFecha, DscTituloPaginator, GetFecActualMaxCal, iconVer, limpiarTexto, ngClassAceptarModal, ngClassSalirModal, openModalMensaje, strMatTablePaginator } from 'src/app/general/variables';
import { Fur } from 'src/app/models/Fur';
import { MailDetalle } from 'src/app/models/MailDetalle';
import { ExternosService } from 'src/app/services/externos/externos.service';
import { ModalMailDetalleComponent } from './modal-mail-detalle/modal-mail-detalle.component';

@Component({
  selector: 'app-bandeja-notif',
  templateUrl: './bandeja-notif.component.html',
  styleUrls: ['./bandeja-notif.component.css']
})
export class BandejaNotifComponent implements OnInit {

  strFechaMaxCal: string;
  strDscValFecIni: string = null;
  strDscValFecFin: string = null;
  strFechaIniFiltro: string ;
  strFechaFinFiltro: string;
  fur: Fur = null;
  mailDetalle: MailDetalle = null;
  dataSource: MatTableDataSource<MailDetalle>;
  dataSource2: MatTableDataSource<MailDetalle>;
  @ViewChild('MatPaginator1') paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('MatPaginator2') paginator2: MatPaginator;
  @ViewChild(MatSort) sort2: MatSort;

  matTableColumnsDef = ['item', 'asunto', 'fecha', 'destinatario', 'acciones'];
  matTableColumnsEtiq = ['Ítem', 'Asunto', 'Fecha Envío', 'Destinatario', 'Detalle'];
  strMatTablePaginator1 = strMatTablePaginator;
  strMatTablePaginator2 = strMatTablePaginator;
  iconVer = iconVer;
  listMailDetalle: MailDetalle[] = [];
  listMailDetalle2: MailDetalle[] = [];
  ngClassAceptarModal = ngClassAceptarModal;
  ngClassSalirModal = ngClassSalirModal;
  strDscMensajeSpinner = DscMensajeSpinner;

  constructor(public matDialog: MatDialog,
              private spinner: NgxSpinnerService,
              protected externosService: ExternosService, ) { }

  ngOnInit() {

    this.strFechaMaxCal = GetFecActualMaxCal();



  }

  _KUcambiofechaIni(valor) {

    this.strDscValFecIni = valor.target.validationMessage;

    this.strFechaIniFiltro = valor.target.value;

  }

  _KUcambiofechaFin(valor) {

    this.strDscValFecFin = valor.target.validationMessage;

    this.strFechaFinFiltro = valor.target.value;

  }

  setFurBandeja(fur: Fur) {

      this.fur = fur;

      this._cargarNotifPorEstado(CodNuevoBand, 1);

  }

  _buscar() {

    let fechaIniFiltro: Date = new Date(this.strFechaIniFiltro);
    let fechaFinFiltro: Date = new Date(this.strFechaFinFiltro);
    let boolFlgFechaIniVacio: boolean = (this.strDscValFecIni == DscMensajeValFecha || this.strDscValFecIni == null);
    let boolFlgFechaFinVacio: boolean = (this.strDscValFecFin == DscMensajeValFecha || this.strDscValFecFin == null);
    let numCantFechaFiltro = 0;
    let boolFlgFiltrarFecha = false;
    const boolFlgFechaIniOK = !isNaN(Date.parse(this.strFechaIniFiltro));
    const boolFlgFechaFinOK = !isNaN(Date.parse(this.strFechaFinFiltro));
    // let numIndex:number = 0;

    if (boolFlgFechaIniOK) {

      boolFlgFechaIniVacio = false;

    }

    if (boolFlgFechaFinOK) {

      boolFlgFechaFinVacio = false;

    }

    if (!boolFlgFechaIniVacio) {

      // if(isNaN(Date.parse(this.strFechaIniFiltro)))
      if (boolFlgFechaIniOK == false) {

        openModalMensaje('Formulario Virtual', 'La fecha inicial no es válida, por favor verifique.', this.matDialog).afterClosed().subscribe(result => {

        });

        return;

      }

      numCantFechaFiltro++;


    }

    if (!boolFlgFechaFinVacio) {

      // if(isNaN(Date.parse(this.strFechaFinFiltro)))
      if (boolFlgFechaFinOK == false) {

        openModalMensaje('Formulario Virtual', 'La fecha final no es válida, por favor verifique.', this.matDialog).afterClosed().subscribe(result => {

        });

        return;

      }

      numCantFechaFiltro++;


    }

    if (!boolFlgFechaIniVacio && boolFlgFechaFinVacio) {

      openModalMensaje('Formulario Virtual', 'Debe ingresar la fecha final, por favor verifique.', this.matDialog).afterClosed().subscribe(result => {

      });

      return;


    }

    if (numCantFechaFiltro == 2) {

      fechaIniFiltro.setDate(fechaIniFiltro.getDate() + 1);
      fechaFinFiltro.setDate(fechaFinFiltro.getDate() + 1);

      fechaIniFiltro = new Date(fechaIniFiltro.getFullYear(), fechaIniFiltro.getMonth(), fechaIniFiltro.getDate());
      fechaFinFiltro = new Date(fechaFinFiltro.getFullYear(), fechaFinFiltro.getMonth(), fechaFinFiltro.getDate());

      if (fechaIniFiltro > fechaFinFiltro) {

        openModalMensaje('Formulario Virtual', 'La fecha inicial no debe ser mayor al final, por favor verifique.', this.matDialog).afterClosed().subscribe(result => {

        });

        return;

      }

      boolFlgFiltrarFecha = true;

    }

    if (boolFlgFiltrarFecha == false) {

      openModalMensaje('Formulario Virtual', 'Debe ingresar el rango de fechas, por favor verifique.', this.matDialog).afterClosed().subscribe(result => {

      });

      return;

    }

    this._resetListado();


    this.mailDetalle = new MailDetalle();

    this.mailDetalle.cbpmmailIdcodtip = CodTipoFichaFUR;
    this.mailDetalle.nbpmmailIdtipo = this.fur.nfurId;
    this.mailDetalle.strFechaIniFiltro = ConvertDateTimeToStrForBD(fechaIniFiltro, false);
    this.mailDetalle.strFechaFinFiltro = ConvertDateTimeToStrForBD(fechaFinFiltro, false);
    this.mailDetalle.cbpmmaildetEstado = CodNuevoBand;

    this._cargarListaNotif(this.mailDetalle, 1, true);

    // this.spinner.show();

    // this.externosService.listarNotifBandeja(this.mailDetalle).subscribe(data=>{

    //   this.spinner.hide();

    //   console.log("====data listarNotifBandeja");
    //   console.log(data);

    //   if(data != null)
    //   {

    //     data.forEach(element => {

    //       this.listMailDetalle[numIndex] = new MailDetalle();
    //       this.listMailDetalle[numIndex].cbpmmaildetAsunto = element.cbpmmaildetAsunto;
    //       this.listMailDetalle[numIndex].cbpmmaildetContenido = element.cbpmmaildetContenido;
    //       this.listMailDetalle[numIndex].cbpmmaildetDestinatario = element.cbpmmaildetDestinatario;
    //       this.listMailDetalle[numIndex].cbpmmaildetEstado = element.cbpmmaildetEstado;
    //       this.listMailDetalle[numIndex].cbpmmaildetRemitente = element.cbpmmaildetRemitente;
    //       this.listMailDetalle[numIndex].strFechaEnvio = element.strFechaEnvio;
    //       this.listMailDetalle[numIndex].nbpmmaildetId = element.nbpmmaildetId;

    //       numIndex++;

    //     });

    //   }

    //   this._resetMatTable();

    // },
    // err=>{
    //   this.spinner.hide();
    //   console.log(err);
    // });

  }

  _limpiar() {


    this.strFechaIniFiltro = '';
    this.strFechaFinFiltro = '';

  }

  _cargarListaNotif(param: MailDetalle, numCaso: number, boolFlgBuscar: boolean) {

    const listResultBusq: MailDetalle[] = [];
    let numIndex = 0;

    this.spinner.show();

    this.externosService.listarNotifBandeja(param).subscribe(data => {

      this.spinner.hide();

      // console.log("====data listarNotifBandeja");
      // console.log(data);

      if (data != null) {

        data.forEach(element => {

          listResultBusq[numIndex] = new MailDetalle();
          listResultBusq[numIndex].cbpmmaildetAsunto = limpiarTexto(element.cbpmmaildetAsunto);
          listResultBusq[numIndex].cbpmmaildetContenido = element.cbpmmaildetContenido;
          listResultBusq[numIndex].cbpmmaildetDestinatario = element.cbpmmaildetDestinatario;
          listResultBusq[numIndex].cbpmmaildetEstado = element.cbpmmaildetEstado;
          listResultBusq[numIndex].cbpmmaildetRemitente = element.cbpmmaildetRemitente;
          listResultBusq[numIndex].strFechaEnvio = element.strFechaEnvio;
          listResultBusq[numIndex].nbpmmaildetId = element.nbpmmaildetId;

          numIndex++;

          // console.log("====data listarNotifBandeja for 1");

        });


        switch (numCaso) {
          case 1:

            this.listMailDetalle = listResultBusq;
            this._resetMatTable();

            break;

          case 2:

            // console.log("====data listarNotifBandeja for 2");

            this.listMailDetalle2 = listResultBusq;

            // console.log("====data listarNotifBandeja for 3");
            this._resetMatTable2();

            break;

          default:
            break;
        }

      }

      if (numIndex == 0 && boolFlgBuscar) {

        openModalMensaje('Formulario Virtual', 'No se encontró ningún resultado, por favor verifique.', this.matDialog).afterClosed().subscribe(result => {

        });

        return;

      }

    },
    err => {
      this.spinner.hide();
      console.log(err);
    });


  }

  _getAriaSelectedTab(numTab: number) {

    let vFlgReturn = false;

    switch (numTab) {
      case 1:

        vFlgReturn = true;

        break;

      case 2:

        vFlgReturn = false;

        break;

      default:
        break;
    }

    return vFlgReturn;

  }
  _resetListado() {

    this.listMailDetalle = [];

    this._resetMatTable();

  }

  _resetMatTable() {

    if (this.listMailDetalle) {

      setTimeout(() => {

        this.dataSource = new MatTableDataSource(this.listMailDetalle);

        if (this.paginator != null) {this.paginator._intl.itemsPerPageLabel = DscTituloPaginator; } // this.paginator._intl.itemsPerPageLabel = DscTituloPaginator;

        // this.paginator._intl.itemsPerPageLabel = DscTituloPaginator;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

      }, 1);

    }



  }

  _cargarRecibidos() {

    this._cargarNotifPorEstado(CodRecibidoBand, 2);

    // this.mailDetalle = new MailDetalle();

    // this.mailDetalle.cbpmmailIdcodtip = CodTipoFichaFUR;
    // this.mailDetalle.nbpmmailIdtipo = this.fur.nfurId;
    // this.mailDetalle.cbpmmaildetEstado = CodRecibidoBand;

    // this._cargarListaNotif(this.mailDetalle,2);


  }


  _cargarNotifPorEstado(strEstado: string, numCaso: number) {

    this.mailDetalle = new MailDetalle();

    this.mailDetalle.cbpmmailIdcodtip = CodTipoFichaFUR;
    this.mailDetalle.nbpmmailIdtipo = this.fur.nfurId;
    this.mailDetalle.cbpmmaildetEstado = strEstado;
    // this.mailDetalle.cbpmmaildetEstado = CodRecibidoBand;

    this._cargarListaNotif(this.mailDetalle, numCaso, false);


  }

  _resetMatTable2() {

    // console.log("====data listarNotifBandeja for 4");

    if (this.listMailDetalle2) {

      // console.log("====data listarNotifBandeja for 5");

      setTimeout(() => {

        // console.log("====data listarNotifBandeja for 6");

        this.dataSource2 = new MatTableDataSource(this.listMailDetalle2);

        if (this.paginator2 != null) {this.paginator2._intl.itemsPerPageLabel = DscTituloPaginator; } // this.paginator._intl.itemsPerPageLabel = DscTituloPaginator;

        // this.paginator._intl.itemsPerPageLabel = DscTituloPaginator;
        this.dataSource2.paginator = this.paginator2;
        this.dataSource2.sort = this.sort2;

        // console.log("====data listarNotifBandeja for 7");

      }, 10);

    }



  }

  _verContenido(row: MailDetalle, numCaso: number) {

    switch (numCaso) {
      case 1:

        row.cbpmmaildetEstado = CodRecibidoBand;

        this.spinner.show();

        this.externosService.actualizarNotifBandeja(row).subscribe(data => {

          this.spinner.hide();

          this._abrirModalContenido(row, numCaso);

        },
        err => {
          this.spinner.hide();
          console.log(err);
        });

        // if(row.cbpmmaildetEstado == CodRecibidoBand)
        // {

        //   this._abrirModalContenido(row,numCaso);


        // }else{

        //   row.cbpmmaildetEstado = CodRecibidoBand;

        //   this.spinner.show();

        //   this.externosService.actualizarNotifBandeja(row).subscribe(data=>{

        //     this.spinner.hide();

        //     this._abrirModalContenido(row,numCaso);

        //   },
        //   err=>{
        //     this.spinner.hide();
        //     console.log(err);
        //   });


        // }


        break;

      case 2:

        this._abrirModalContenido(row, numCaso);

        break;

      default:
        break;
    }


  }

  _abrirModalContenido(row: MailDetalle, numCaso: number) {

    const  modal = this.matDialog.open(ModalMailDetalleComponent, { width: '80%', height: '87%', data: {mailDetalle : row}});

    modal.afterClosed().subscribe(
      data => {

        switch (numCaso) {
          case 1:

            this.listMailDetalle.splice(this.listMailDetalle.indexOf(row), 1);
            this._resetMatTable();

            break;

          case 2:



            break;

          default:
            break;
        }



      } );

    // this.matDialog.open(ModalMailDetalleComponent,{ width: '80%',height:'87%', data: {mailDetalle : row}});

  }

}
